import { IValues } from "@rentiohq/shared-frontend/dist/redux/form/form.utils";
import { getLocalizedText } from "@rentiohq/shared-frontend/dist/utils/i18n/i18n.utils";
import { getContractDates } from "utils/contract";
import { EField, IExtraData } from "./schema.createDocument.types";

export const NO_CONTRACT_ID = "-1";

export const getInitialValues = ({
  document,
  files,
  contractId,
}: IExtraData): IValues => {
  if (document) {
    return {
      [EField.Name]: document.filename,
      [EField.Category]: document.categoryId,
      [EField.Contract]: contractId || NO_CONTRACT_ID,
    };
  }

  if (files) {
    return {
      [EField.Name]: files[0].name,
      [EField.Contract]: NO_CONTRACT_ID,
    };
  }

  return {};
};

export const getContractOptions = (extraData: IExtraData) => {
  const contractDates = (extraData.contracts || []).map(contract => ({
    id: contract?.id,
    value: getContractDates(contract),
  }));
  return [
    { id: NO_CONTRACT_ID, value: getLocalizedText("system.none") },
    ...contractDates,
  ];
};
